import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CONST_AUTOADM } from '../../../../const';
import { descargarDesdeUrl } from '../../../../utilitarios/descargar';

@Component({
  selector: 'app-pdf-preview-modal',
  templateUrl: './pdf-preview-modal.component.html',
  styleUrls: ['./pdf-preview-modal.component.css']
})
export class PdfPreviewModalComponent implements OnChanges {
  @Input() open = false;
  @Input() title = '';
  @Input() fileName = 'documento.pdf';
  @Input() src: string | null = null;

  @Output() closed = new EventEmitter<void>();

  safeSrc: SafeResourceUrl | null = null;
  CONST_AUTOADM = CONST_AUTOADM;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.src) {
      this.safeSrc = this.src
        ? this.sanitizer.bypassSecurityTrustResourceUrl(this.src)
        : null;
    }
  }

  close(): void {
    this.closed.emit();
  }

  download(): void {
    if (!this.src) {
      return;
    }
    descargarDesdeUrl(this.src, this.fileName);
  }
}
